import React, { useState } from 'react';
import Sidebar from './Sidebar';
import ComplianceChatbot from './ComplianceChatbot';
import { SubscriptionTier, TIER_DISPLAY_NAMES, TIER_BADGE_COLORS } from '../types';
import './MainLayout.css';

interface MainLayoutProps {
  children: React.ReactNode;
  activeSection: string;
  onSectionChange: (section: string) => void;
  projectName?: string;
  projectId?: string;
  username?: string;
  userRole?: 'admin' | 'member' | string;
  subscriptionTier?: SubscriptionTier;
  onLogout: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  activeSection,
  onSectionChange,
  projectName,
  projectId,
  username,
  userRole,
  subscriptionTier = 'free',
  onLogout
}) => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const getSectionTitle = () => {
    switch (activeSection) {
      case 'questionnaire': return 'Upload Questionnaire';
      case 'knowledge-base': return 'Knowledge Base';
      case 'team': return 'Team Management';
      case 'subscription': return 'Subscription';
      case 'settings': return 'Project Settings';
      default: return '';
    }
  };

  const tierDisplayName = TIER_DISPLAY_NAMES[subscriptionTier] || 'Free';
  const tierBadgeColor = TIER_BADGE_COLORS[subscriptionTier] || TIER_BADGE_COLORS.free;

  return (
    <div className="main-layout">
      <Sidebar
        activeSection={activeSection}
        onSectionChange={onSectionChange}
        projectName={projectName}
        userRole={userRole}
      />
      <div className="main-content">
        <header className="top-header">
          <div className="header-title">
            {getSectionTitle()}
            {userRole === 'admin' && <span className="role-indicator">Admin</span>}
            <span
              className="tier-badge"
              style={{ backgroundColor: tierBadgeColor }}
            >
              {tierDisplayName}
            </span>
          </div>
          <div className="header-actions">
            <button
              className="chatbot-trigger-btn"
              onClick={() => setIsChatbotOpen(true)}
            >
              🤖 Ask Compliance Bot
            </button>
            <div className="user-info">
              <span className="user-avatar">👤</span>
              <span className="user-name">{username}</span>
            </div>
            <button onClick={onLogout} className="logout-btn">
              Sign Out
            </button>
          </div>
        </header>
        <main className="content-area">
          {children}
        </main>
      </div>

      {projectId && (
        <ComplianceChatbot
          isOpen={isChatbotOpen}
          onClose={() => setIsChatbotOpen(false)}
          projectId={projectId}
          projectName={projectName}
        />
      )}
    </div>
  );
};

export default MainLayout;

